import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';

@Component({
    selector: 'input-boolean',
    templateUrl: './input.boolean.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputBoolean),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputBoolean implements OnInit, OnChanges, ControlValueAccessor {

    value: boolean;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (string) => string; 

    error: string;

    // control: FormControl;

    ngOnInit() {
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeValue(event: boolean) {
      this.value = event;
      this.propagateChange(event);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }
      this.error = null;
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        // if (value != this.value) {
          this.changeValue(value);
        // }
        this.value = value;
      // }
    }

    propagateChange = (_: boolean) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}